import {
  SwapMarket,
  SwapProContext,
  ExchangeEstimate,
  SWAP_TYPE,
} from '../../../pages/SwapPage';
import {
  IServerRoute,
  getTokensOfRoute,
} from '../../../services/smartRouterFromServer';
import React, { useContext, useEffect, useState } from 'react';
import { getDexIcon } from './routeHelpers';
import { isMobile } from '../../../utils/device';
import { FormattedMessage, useIntl } from 'react-intl';
import { toRealSymbol } from '../../../utils/token';
import { FaAngleRight } from '../../reactIcons/index';
import { PolygonRight } from '../../icon/Common';
import { EstimateSwapView } from 'src/services/swapTypes';
import { REF_FI_BEST_MARKET_ROUTE } from '../../../state/swapHooks/swapStateShared';

export const SwapRoute = ({
  route,
  market,
  routeServer,
}: {
  route?: EstimateSwapView[];
  market: SwapMarket;
  routeServer?: IServerRoute;
}) => {
  const [tokens, setTokens] = useState([]);
  useEffect(() => {
    if (route) {
      setTokens(route[0].tokens);
    } else if (routeServer) {
      getTokensOfRoute(routeServer).then((routeTokens) => {
        setTokens(routeTokens);
      });
    }
  }, [route, routeServer]);

  const { swapType } = useContext(SwapProContext);

  return (
    <div className="frcs">
      <div
        style={{
          height: '13px',
          width: '13px',
        }}
        className="frcc mr-1.5"
      >
        {getDexIcon(market)}
      </div>

      {isMobile() &&
        swapType === SWAP_TYPE.Pro &&
        sessionStorage.getItem(REF_FI_BEST_MARKET_ROUTE) ===
          market.toString() && (
          <div className="px-1 mr-1 rounded-2xl text-10px bg-gradientFromHover text-black">
            <FormattedMessage
              id="best"
              defaultMessage={'Best'}
            ></FormattedMessage>
          </div>
        )}

      <div
        className="bg-limitOrderInputColor mr-1"
        style={{
          height: '10px',
          width: '1px',
        }}
      ></div>
      <div
        className="frcs"
        style={{
          maxWidth: isMobile() ? '180px' : '',
        }}
      >
        {tokens &&
          tokens.map((token, index) => {
            return (
              <div
                key={index}
                className={`text-xs ${
                  tokens.length === 3 && toRealSymbol(token.symbol).length > 7
                    ? 'xsm:overflow-hidden'
                    : ''
                }  ml-0.5 text-primaryText frcs`}
              >
                {index > 0 && <FaAngleRight />}
                <span
                  className={
                    tokens.length === 3 && toRealSymbol(token.symbol).length > 7
                      ? 'overflow-hidden overflow-ellipsis'
                      : ''
                  }
                >
                  {toRealSymbol(token.symbol)}
                </span>
              </div>
            );
          })}

        <span className="lg:hidden ml-1.5">
          <PolygonRight></PolygonRight>
        </span>
      </div>
    </div>
  );
};

export const SwapRouteMoreThan2 = ({
  market,
  trade,
  throughPools,
}: {
  market: SwapMarket;
  trade: ExchangeEstimate;
  throughPools: number;
}) => {
  const intl = useIntl();

  const { swapType } = useContext(SwapProContext);
  return (
    <div className="frcs">
      <div
        style={{
          height: '13px',
          width: '13px',
        }}
        className="frcc mr-1.5"
      >
        {getDexIcon(market)}
      </div>

      {isMobile() &&
        swapType === SWAP_TYPE.Pro &&
        sessionStorage.getItem(REF_FI_BEST_MARKET_ROUTE) ===
          market.toString() && (
          <div className="px-1 mr-1 rounded-2xl text-10px bg-gradientFromHover text-black">
            <FormattedMessage
              id="best"
              defaultMessage={'Best'}
            ></FormattedMessage>
          </div>
        )}

      <div
        className="bg-limitOrderInputColor mr-1"
        style={{
          height: '10px',
          width: '1px',
        }}
      ></div>
      <div className="frcs text-primaryText">
        {intl.locale === 'zh-CN' &&
          intl.formatMessage({
            id: 'steps_in_the_route_zh',
          })}
        <span className={intl.locale === 'zh-CN' ? 'mr-0' : 'mr-1'}>
          {throughPools}
        </span>

        <FormattedMessage
          id="steps_in_the_route"
          defaultMessage={'steps in the route'}
        ></FormattedMessage>

        <span className="lg:hidden ml-1.5">
          <PolygonRight></PolygonRight>
        </span>
      </div>
    </div>
  );
};
